<template lang="html">
  <div>
    <slot></slot>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/ui/Container.vue